module.exports = __webpack_public_path__ + "img/share-popup.dc1dfc40.svg";